module.exports = __webpack_public_path__ + "static/media/notification_ding.1d83366f.mp3";